@file:OptIn(InternalResourceApi::class)

package showcaseapp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.RegionQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/showcaseapp.composeapp.generated.resources/"

@delegate:ResourceContentHash(84_768_096)
internal val Res.string.Url: StringResource by lazy {
      StringResource("string:Url", "Url", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10, 15),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 15),
      ))
    }

@delegate:ResourceContentHash(54_238_794)
internal val Res.string._off: StringResource by lazy {
      StringResource("string:_off", "_off", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 26, 16),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26, 16),
      ))
    }

@delegate:ResourceContentHash(54_536_594)
internal val Res.string._on: StringResource by lazy {
      StringResource("string:_on", "_on", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 43, 15),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43, 15),
      ))
    }

@delegate:ResourceContentHash(-94_264_874)
internal val Res.string.about: StringResource by lazy {
      StringResource("string:about", "about", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 59, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59, 21),
      ))
    }

@delegate:ResourceContentHash(-1_564_993_312)
internal val Res.string.ad_mob_banner_id: StringResource by lazy {
      StringResource("string:ad_mob_banner_id", "ad_mob_banner_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81, 76),
      ))
    }

@delegate:ResourceContentHash(207_713_885)
internal val Res.string.ad_mob_list_item_native_id: StringResource by lazy {
      StringResource("string:ad_mob_list_item_native_id", "ad_mob_list_item_native_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158, 86),
      ))
    }

@delegate:ResourceContentHash(1_375_482_188)
internal val Res.string.ad_mob_main_page_native_id: StringResource by lazy {
      StringResource("string:ad_mob_main_page_native_id", "ad_mob_main_page_native_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245, 86),
      ))
    }

@delegate:ResourceContentHash(-2_072_647_712)
internal val Res.string.ad_mob_setting_page_native_id: StringResource by lazy {
      StringResource("string:ad_mob_setting_page_native_id", "ad_mob_setting_page_native_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 332, 89),
      ))
    }

@delegate:ResourceContentHash(-357_592_765)
internal val Res.string.ad_mob_splash_id: StringResource by lazy {
      StringResource("string:ad_mob_splash_id", "ad_mob_splash_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 422, 76),
      ))
    }

@delegate:ResourceContentHash(1_646_122_719)
internal val Res.string.ad_mob_test_banner_id: StringResource by lazy {
      StringResource("string:ad_mob_test_banner_id", "ad_mob_test_banner_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 499, 81),
      ))
    }

@delegate:ResourceContentHash(639_498_084)
internal val Res.string.ad_mob_test_list_item_native_1_id: StringResource by lazy {
      StringResource("string:ad_mob_test_list_item_native_1_id", "ad_mob_test_list_item_native_1_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 581, 93),
      ))
    }

@delegate:ResourceContentHash(-2_009_850_637)
internal val Res.string.ad_mob_test_list_item_native_id: StringResource by lazy {
      StringResource("string:ad_mob_test_list_item_native_id", "ad_mob_test_list_item_native_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 675, 91),
      ))
    }

@delegate:ResourceContentHash(560_097_260)
internal val Res.string.ad_mob_test_splash_id: StringResource by lazy {
      StringResource("string:ad_mob_test_splash_id", "ad_mob_test_splash_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 767, 81),
      ))
    }

@delegate:ResourceContentHash(878_447_542)
internal val Res.string.add: StringResource by lazy {
      StringResource("string:add", "add", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 147, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 919, 15),
      ))
    }

@delegate:ResourceContentHash(-167_631_893)
internal val Res.string.addSource: StringResource by lazy {
      StringResource("string:addSource", "addSource", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 81, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 849, 33),
      ))
    }

@delegate:ResourceContentHash(-722_612_814)
internal val Res.string.add_success: StringResource by lazy {
      StringResource("string:add_success", "add_success", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 111, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 883, 35),
      ))
    }

@delegate:ResourceContentHash(1_339_303_478)
internal val Res.string.ads: StringResource by lazy {
      StringResource("string:ads", "ads", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 211, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 975, 15),
      ))
    }

@delegate:ResourceContentHash(-1_838_199_930)
internal val Res.string.ads_loading: StringResource by lazy {
      StringResource("string:ads_loading", "ads_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 167, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 935, 39),
      ))
    }

@delegate:ResourceContentHash(691_070_065)
internal val Res.string.ai_allow_cleartext: StringResource by lazy {
      StringResource("string:ai_allow_cleartext", "ai_allow_cleartext", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 231, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 991, 78),
      ))
    }

@delegate:ResourceContentHash(1_908_621_524)
internal val Res.string.ai_attempt_history: StringResource by lazy {
      StringResource("string:ai_attempt_history", "ai_attempt_history", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_creation_details.commonMain.cvr", 10, 42),
        ResourceItem(setOf(), "${MD}values/ai_creation_details.commonMain.cvr", 10, 46),
      ))
    }

@delegate:ResourceContentHash(1_816_725_549)
internal val Res.string.ai_attempt_number: StringResource by lazy {
      StringResource("string:ai_attempt_number", "ai_attempt_number", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 302, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1070, 41),
      ))
    }

@delegate:ResourceContentHash(-2_136_399_625)
internal val Res.string.ai_base_url: StringResource by lazy {
      StringResource("string:ai_base_url", "ai_base_url", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 352, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1112, 31),
      ))
    }

@delegate:ResourceContentHash(1_364_896_653)
internal val Res.string.ai_cancel_confirm: StringResource by lazy {
      StringResource("string:ai_cancel_confirm", "ai_cancel_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 388, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1144, 49),
      ))
    }

@delegate:ResourceContentHash(558_426_251)
internal val Res.string.ai_cancel_task: StringResource by lazy {
      StringResource("string:ai_cancel_task", "ai_cancel_task", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 446, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1194, 38),
      ))
    }

@delegate:ResourceContentHash(1_268_975_534)
internal val Res.string.ai_cancel_upstream_warning: StringResource by lazy {
      StringResource("string:ai_cancel_upstream_warning", "ai_cancel_upstream_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 485, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1233, 170),
      ))
    }

@delegate:ResourceContentHash(1_466_620_859)
internal val Res.string.ai_capability_image_to_image: StringResource by lazy {
      StringResource("string:ai_capability_image_to_image", "ai_capability_image_to_image", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 628, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1404, 56),
      ))
    }

@delegate:ResourceContentHash(-1_325_865_490)
internal val Res.string.ai_capability_image_understanding: StringResource by lazy {
      StringResource("string:ai_capability_image_understanding", "ai_capability_image_understanding", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 681, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1461, 69),
      ))
    }

@delegate:ResourceContentHash(-1_690_641_238)
internal val Res.string.ai_cleartext_warning: StringResource by lazy {
      StringResource("string:ai_cleartext_warning", "ai_cleartext_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 743, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1531, 180),
      ))
    }

@delegate:ResourceContentHash(2_131_410_943)
internal val Res.string.ai_configuration_description: StringResource by lazy {
      StringResource("string:ai_configuration_description", "ai_configuration_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 900, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1712, 116),
      ))
    }

@delegate:ResourceContentHash(1_177_532_552)
internal val Res.string.ai_configuration_snapshot: StringResource by lazy {
      StringResource("string:ai_configuration_snapshot", "ai_configuration_snapshot", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_creation_details.commonMain.cvr", 53, 57),
        ResourceItem(setOf(), "${MD}values/ai_creation_details.commonMain.cvr", 57, 65),
      ))
    }

@delegate:ResourceContentHash(-853_835_249)
internal val Res.string.ai_configuration_title: StringResource by lazy {
      StringResource("string:ai_configuration_title", "ai_configuration_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 1017, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1829, 54),
      ))
    }

@delegate:ResourceContentHash(-1_584_383_863)
internal val Res.string.ai_configure_service: StringResource by lazy {
      StringResource("string:ai_configure_service", "ai_configure_service", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 1060, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1884, 64),
      ))
    }

@delegate:ResourceContentHash(1_847_680_517)
internal val Res.string.ai_connection_test_action: StringResource by lazy {
      StringResource("string:ai_connection_test_action", "ai_connection_test_action", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 1121, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1949, 57),
      ))
    }

@delegate:ResourceContentHash(-714_736_434)
internal val Res.string.ai_connection_test_available: StringResource by lazy {
      StringResource("string:ai_connection_test_available", "ai_connection_test_available", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 1179, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2007, 80),
      ))
    }

@delegate:ResourceContentHash(726_854_434)
internal val Res.string.ai_connection_test_failed: StringResource by lazy {
      StringResource("string:ai_connection_test_failed", "ai_connection_test_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 1244, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2088, 125),
      ))
    }

@delegate:ResourceContentHash(835_427_878)
internal val Res.string.ai_connection_test_note: StringResource by lazy {
      StringResource("string:ai_connection_test_note", "ai_connection_test_note", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 1346, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2214, 151),
      ))
    }

@delegate:ResourceContentHash(-2_061_044_371)
internal val Res.string.ai_copy_image: StringResource by lazy {
      StringResource("string:ai_copy_image", "ai_copy_image", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_gallery.commonMain.cvr", 10, 49),
        ResourceItem(setOf(), "${MD}values/ai_gallery.commonMain.cvr", 10, 49),
      ))
    }

@delegate:ResourceContentHash(-930_781_484)
internal val Res.string.ai_created_at: StringResource by lazy {
      StringResource("string:ai_created_at", "ai_created_at", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_creation_details.commonMain.cvr", 111, 41),
        ResourceItem(setOf(), "${MD}values/ai_creation_details.commonMain.cvr", 123, 37),
      ))
    }

@delegate:ResourceContentHash(1_807_481_329)
internal val Res.string.ai_creation_center_title: StringResource by lazy {
      StringResource("string:ai_creation_center_title", "ai_creation_center_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 1486, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2366, 48),
      ))
    }

@delegate:ResourceContentHash(1_007_767_777)
internal val Res.string.ai_creation_info: StringResource by lazy {
      StringResource("string:ai_creation_info", "ai_creation_info", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_gallery.commonMain.cvr", 60, 40),
        ResourceItem(setOf(), "${MD}values/ai_gallery.commonMain.cvr", 60, 52),
      ))
    }

@delegate:ResourceContentHash(1_643_363_765)
internal val Res.string.ai_creations_empty: StringResource by lazy {
      StringResource("string:ai_creations_empty", "ai_creations_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 1531, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2415, 78),
      ))
    }

@delegate:ResourceContentHash(-1_064_461_795)
internal val Res.string.ai_credential_origin_change_warning: StringResource by lazy {
      StringResource("string:ai_credential_origin_change_warning", "ai_credential_origin_change_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 1606, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2494, 175),
      ))
    }

@delegate:ResourceContentHash(-1_145_221_606)
internal val Res.string.ai_delete_failed: StringResource by lazy {
      StringResource("string:ai_delete_failed", "ai_delete_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 1770, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2670, 120),
      ))
    }

@delegate:ResourceContentHash(-359_899_852)
internal val Res.string.ai_delete_image_confirm: StringResource by lazy {
      StringResource("string:ai_delete_image_confirm", "ai_delete_image_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 1883, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2791, 175),
      ))
    }

@delegate:ResourceContentHash(1_755_688_352)
internal val Res.string.ai_delete_task: StringResource by lazy {
      StringResource("string:ai_delete_task", "ai_delete_task", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 2043, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2967, 38),
      ))
    }

@delegate:ResourceContentHash(435_396_201)
internal val Res.string.ai_error_category: StringResource by lazy {
      StringResource("string:ai_error_category", "ai_error_category", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 2082, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3006, 45),
      ))
    }

@delegate:ResourceContentHash(-845_185_586)
internal val Res.string.ai_face_detected: StringResource by lazy {
      StringResource("string:ai_face_detected", "ai_face_detected", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_generation_privacy.commonMain.cvr", 10, 56),
        ResourceItem(setOf(), "${MD}values/ai_generation_privacy.commonMain.cvr", 10, 64),
      ))
    }

@delegate:ResourceContentHash(2_042_043_150)
internal val Res.string.ai_face_detection_unknown: StringResource by lazy {
      StringResource("string:ai_face_detection_unknown", "ai_face_detection_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_generation_privacy.commonMain.cvr", 67, 69),
        ResourceItem(setOf(), "${MD}values/ai_generation_privacy.commonMain.cvr", 75, 85),
      ))
    }

@delegate:ResourceContentHash(708_651_775)
internal val Res.string.ai_face_not_detected: StringResource by lazy {
      StringResource("string:ai_face_not_detected", "ai_face_not_detected", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_generation_privacy.commonMain.cvr", 137, 52),
        ResourceItem(setOf(), "${MD}values/ai_generation_privacy.commonMain.cvr", 161, 52),
      ))
    }

@delegate:ResourceContentHash(1_384_510_880)
internal val Res.string.ai_file_history: StringResource by lazy {
      StringResource("string:ai_file_history", "ai_file_history", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_creation_details.commonMain.cvr", 153, 39),
        ResourceItem(setOf(), "${MD}values/ai_creation_details.commonMain.cvr", 161, 39),
      ))
    }

@delegate:ResourceContentHash(-1_416_559_018)
internal val Res.string.ai_gallery: StringResource by lazy {
      StringResource("string:ai_gallery", "ai_gallery", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_creation_details.commonMain.cvr", 193, 26),
        ResourceItem(setOf(), "${MD}values/ai_creation_details.commonMain.cvr", 201, 30),
      ))
    }

@delegate:ResourceContentHash(-272_113_055)
internal val Res.string.ai_generate_action: StringResource by lazy {
      StringResource("string:ai_generate_action", "ai_generate_action", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 2124, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3052, 50),
      ))
    }

@delegate:ResourceContentHash(-1_046_628_111)
internal val Res.string.ai_generate_title: StringResource by lazy {
      StringResource("string:ai_generate_title", "ai_generate_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 2175, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3103, 41),
      ))
    }

@delegate:ResourceContentHash(-1_046_628_034)
internal val Res.string.ai_generated_badge: StringResource by lazy {
      StringResource("string:ai_generated_badge", "ai_generated_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 2213, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3145, 42),
      ))
    }

@delegate:ResourceContentHash(1_339_126_645)
internal val Res.string.ai_generated_image_description: StringResource by lazy {
      StringResource("string:ai_generated_image_description", "ai_generated_image_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 2252, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3188, 58),
      ))
    }

@delegate:ResourceContentHash(-2_024_837_381)
internal val Res.string.ai_generation_cancel_failed: StringResource by lazy {
      StringResource("string:ai_generation_cancel_failed", "ai_generation_cancel_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 2307, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3247, 131),
      ))
    }

@delegate:ResourceContentHash(1_483_973_345)
internal val Res.string.ai_generation_enqueue_failed: StringResource by lazy {
      StringResource("string:ai_generation_enqueue_failed", "ai_generation_enqueue_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 2439, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3379, 148),
      ))
    }

@delegate:ResourceContentHash(-776_488_315)
internal val Res.string.ai_generation_privacy_notice: StringResource by lazy {
      StringResource("string:ai_generation_privacy_notice", "ai_generation_privacy_notice", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_generation_privacy.commonMain.cvr", 190, 312),
        ResourceItem(setOf(), "${MD}values/ai_generation_privacy.commonMain.cvr", 214, 296),
      ))
    }

@delegate:ResourceContentHash(1_499_183_635)
internal val Res.string.ai_generation_profile_required: StringResource by lazy {
      StringResource("string:ai_generation_profile_required", "ai_generation_profile_required", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 2560, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3528, 190),
      ))
    }

@delegate:ResourceContentHash(-1_275_751_373)
internal val Res.string.ai_generation_retry_failed: StringResource by lazy {
      StringResource("string:ai_generation_retry_failed", "ai_generation_retry_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 2719, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3719, 94),
      ))
    }

@delegate:ResourceContentHash(333_145_281)
internal val Res.string.ai_image_copied: StringResource by lazy {
      StringResource("string:ai_image_copied", "ai_image_copied", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_gallery.commonMain.cvr", 101, 91),
        ResourceItem(setOf(), "${MD}values/ai_gallery.commonMain.cvr", 113, 91),
      ))
    }

@delegate:ResourceContentHash(-2_045_033_665)
internal val Res.string.ai_image_save_failed: StringResource by lazy {
      StringResource("string:ai_image_save_failed", "ai_image_save_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 2806, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3814, 64),
      ))
    }

@delegate:ResourceContentHash(-1_452_163_992)
internal val Res.string.ai_image_saved: StringResource by lazy {
      StringResource("string:ai_image_saved", "ai_image_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 2863, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3879, 38),
      ))
    }

@delegate:ResourceContentHash(-262_466_433)
internal val Res.string.ai_image_summary_face_detection_failed: StringResource by lazy {
      StringResource("string:ai_image_summary_face_detection_failed", "ai_image_summary_face_detection_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/face_privacy.commonMain.cvr", 10, 122),
        ResourceItem(setOf(), "${MD}values/face_privacy.commonMain.cvr", 10, 138),
      ))
    }

@delegate:ResourceContentHash(1_005_163_436)
internal val Res.string.ai_image_summary_face_privacy: StringResource by lazy {
      StringResource("string:ai_image_summary_face_privacy", "ai_image_summary_face_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/face_privacy.commonMain.cvr", 457, 61),
        ResourceItem(setOf(), "${MD}values/face_privacy.commonMain.cvr", 509, 53),
      ))
    }

@delegate:ResourceContentHash(-1_232_075_368)
internal val Res.string.ai_image_summary_face_privacy_blocked: StringResource by lazy {
      StringResource("string:ai_image_summary_face_privacy_blocked", "ai_image_summary_face_privacy_blocked", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/face_privacy.commonMain.cvr", 133, 125),
        ResourceItem(setOf(), "${MD}values/face_privacy.commonMain.cvr", 149, 153),
      ))
    }

@delegate:ResourceContentHash(648_032_604)
internal val Res.string.ai_image_summary_face_privacy_description: StringResource by lazy {
      StringResource("string:ai_image_summary_face_privacy_description", "ai_image_summary_face_privacy_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/face_privacy.commonMain.cvr", 259, 197),
        ResourceItem(setOf(), "${MD}values/face_privacy.commonMain.cvr", 303, 205),
      ))
    }

@delegate:ResourceContentHash(-1_816_619_321)
internal val Res.string.ai_image_summary_failed: StringResource by lazy {
      StringResource("string:ai_image_summary_failed", "ai_image_summary_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 2910, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3918, 83),
      ))
    }

@delegate:ResourceContentHash(-578_643_034)
internal val Res.string.ai_image_summary_generating: StringResource by lazy {
      StringResource("string:ai_image_summary_generating", "ai_image_summary_generating", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 2990, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4002, 71),
      ))
    }

@delegate:ResourceContentHash(1_218_193_248)
internal val Res.string.ai_local_storage_reclaimable: StringResource by lazy {
      StringResource("string:ai_local_storage_reclaimable", "ai_local_storage_reclaimable", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_service_info.commonMain.cvr", 10, 236),
        ResourceItem(setOf(), "${MD}values/ai_service_info.commonMain.cvr", 10, 228),
      ))
    }

@delegate:ResourceContentHash(1_795_021_858)
internal val Res.string.ai_model: StringResource by lazy {
      StringResource("string:ai_model", "ai_model", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 3697, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4745, 24),
      ))
    }

@delegate:ResourceContentHash(-981_856_428)
internal val Res.string.ai_model_catalog_empty: StringResource by lazy {
      StringResource("string:ai_model_catalog_empty", "ai_model_catalog_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 3062, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4074, 118),
      ))
    }

@delegate:ResourceContentHash(1_868_632_839)
internal val Res.string.ai_model_catalog_failed: StringResource by lazy {
      StringResource("string:ai_model_catalog_failed", "ai_model_catalog_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 3181, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4193, 155),
      ))
    }

@delegate:ResourceContentHash(-737_703_110)
internal val Res.string.ai_model_catalog_load: StringResource by lazy {
      StringResource("string:ai_model_catalog_load", "ai_model_catalog_load", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 3333, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4349, 57),
      ))
    }

@delegate:ResourceContentHash(742_426_337)
internal val Res.string.ai_model_catalog_unsupported: StringResource by lazy {
      StringResource("string:ai_model_catalog_unsupported", "ai_model_catalog_unsupported", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 3399, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4407, 136),
      ))
    }

@delegate:ResourceContentHash(-876_805_194)
internal val Res.string.ai_model_generation_hint: StringResource by lazy {
      StringResource("string:ai_model_generation_hint", "ai_model_generation_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 3532, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4544, 96),
      ))
    }

@delegate:ResourceContentHash(-196_325_109)
internal val Res.string.ai_model_understanding_hint: StringResource by lazy {
      StringResource("string:ai_model_understanding_hint", "ai_model_understanding_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 3613, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4641, 103),
      ))
    }

@delegate:ResourceContentHash(-307_892_995)
internal val Res.string.ai_more_actions: StringResource by lazy {
      StringResource("string:ai_more_actions", "ai_more_actions", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_gallery.commonMain.cvr", 193, 39),
        ResourceItem(setOf(), "${MD}values/ai_gallery.commonMain.cvr", 205, 39),
      ))
    }

@delegate:ResourceContentHash(518_540_497)
internal val Res.string.ai_new_configuration: StringResource by lazy {
      StringResource("string:ai_new_configuration", "ai_new_configuration", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 3722, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4770, 52),
      ))
    }

@delegate:ResourceContentHash(-1_026_938_296)
internal val Res.string.ai_next_creation: StringResource by lazy {
      StringResource("string:ai_next_creation", "ai_next_creation", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_gallery.commonMain.cvr", 233, 44),
        ResourceItem(setOf(), "${MD}values/ai_gallery.commonMain.cvr", 245, 44),
      ))
    }

@delegate:ResourceContentHash(1_990_391_396)
internal val Res.string.ai_origin_change_confirm: StringResource by lazy {
      StringResource("string:ai_origin_change_confirm", "ai_origin_change_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 3767, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4823, 100),
      ))
    }

@delegate:ResourceContentHash(232_581_644)
internal val Res.string.ai_original_metadata: StringResource by lazy {
      StringResource("string:ai_original_metadata", "ai_original_metadata", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_creation_details.commonMain.cvr", 220, 48),
        ResourceItem(setOf(), "${MD}values/ai_creation_details.commonMain.cvr", 232, 60),
      ))
    }

@delegate:ResourceContentHash(-484_910_331)
internal val Res.string.ai_previous_creation: StringResource by lazy {
      StringResource("string:ai_previous_creation", "ai_previous_creation", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_gallery.commonMain.cvr", 278, 48),
        ResourceItem(setOf(), "${MD}values/ai_gallery.commonMain.cvr", 290, 52),
      ))
    }

@delegate:ResourceContentHash(-666_914_223)
internal val Res.string.ai_processing_time: StringResource by lazy {
      StringResource("string:ai_processing_time", "ai_processing_time", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_gallery.commonMain.cvr", 327, 58),
        ResourceItem(setOf(), "${MD}values/ai_gallery.commonMain.cvr", 343, 58),
      ))
    }

@delegate:ResourceContentHash(729_689_184)
internal val Res.string.ai_profile_archive: StringResource by lazy {
      StringResource("string:ai_profile_archive", "ai_profile_archive", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 4172, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5216, 46),
      ))
    }

@delegate:ResourceContentHash(-1_144_772_482)
internal val Res.string.ai_profile_archive_confirm: StringResource by lazy {
      StringResource("string:ai_profile_archive_confirm", "ai_profile_archive_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 3864, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4924, 62),
      ))
    }

@delegate:ResourceContentHash(1_833_847_217)
internal val Res.string.ai_profile_archive_pending_tasks: StringResource by lazy {
      StringResource("string:ai_profile_archive_pending_tasks", "ai_profile_archive_pending_tasks", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 3931, 240),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4987, 228),
      ))
    }

@delegate:ResourceContentHash(870_689_247)
internal val Res.string.ai_profile_delete_confirm: StringResource by lazy {
      StringResource("string:ai_profile_delete_confirm", "ai_profile_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 4223, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5263, 61),
      ))
    }

@delegate:ResourceContentHash(667_733_862)
internal val Res.string.ai_profile_delete_named: StringResource by lazy {
      StringResource("string:ai_profile_delete_named", "ai_profile_delete_named", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 4289, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5325, 47),
      ))
    }

@delegate:ResourceContentHash(772_637_943)
internal val Res.string.ai_profile_delete_pending_tasks: StringResource by lazy {
      StringResource("string:ai_profile_delete_pending_tasks", "ai_profile_delete_pending_tasks", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 4337, 207),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5373, 195),
      ))
    }

@delegate:ResourceContentHash(67_645_553)
internal val Res.string.ai_profile_edit: StringResource by lazy {
      StringResource("string:ai_profile_edit", "ai_profile_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 4591, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5611, 39),
      ))
    }

@delegate:ResourceContentHash(-1_930_965_762)
internal val Res.string.ai_profile_edit_named: StringResource by lazy {
      StringResource("string:ai_profile_edit_named", "ai_profile_edit_named", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 4545, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5569, 41),
      ))
    }

@delegate:ResourceContentHash(1_188_080_334)
internal val Res.string.ai_profile_empty_compact: StringResource by lazy {
      StringResource("string:ai_profile_empty_compact", "ai_profile_empty_compact", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 4639, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5651, 56),
      ))
    }

@delegate:ResourceContentHash(-1_612_980_000)
internal val Res.string.ai_profile_error_archive_failed: StringResource by lazy {
      StringResource("string:ai_profile_error_archive_failed", "ai_profile_error_archive_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 4704, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5708, 95),
      ))
    }

@delegate:ResourceContentHash(-268_199_266)
internal val Res.string.ai_profile_error_cleartext_confirmation: StringResource by lazy {
      StringResource("string:ai_profile_error_cleartext_confirmation", "ai_profile_error_cleartext_confirmation", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 4792, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5804, 123),
      ))
    }

@delegate:ResourceContentHash(-495_237_351)
internal val Res.string.ai_profile_error_load_failed: StringResource by lazy {
      StringResource("string:ai_profile_error_load_failed", "ai_profile_error_load_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 4912, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5928, 88),
      ))
    }

@delegate:ResourceContentHash(1_747_402_449)
internal val Res.string.ai_profile_error_model_invalid: StringResource by lazy {
      StringResource("string:ai_profile_error_model_invalid", "ai_profile_error_model_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 4997, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6017, 94),
      ))
    }

@delegate:ResourceContentHash(1_790_198_320)
internal val Res.string.ai_profile_error_name_required: StringResource by lazy {
      StringResource("string:ai_profile_error_name_required", "ai_profile_error_name_required", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 5084, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6112, 66),
      ))
    }

@delegate:ResourceContentHash(-44_591_727)
internal val Res.string.ai_profile_error_save_failed: StringResource by lazy {
      StringResource("string:ai_profile_error_save_failed", "ai_profile_error_save_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 5163, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6179, 88),
      ))
    }

@delegate:ResourceContentHash(867_304_227)
internal val Res.string.ai_profile_error_token_required: StringResource by lazy {
      StringResource("string:ai_profile_error_token_required", "ai_profile_error_token_required", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 5248, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6268, 119),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("Url", Res.string.Url)
  map.put("_off", Res.string._off)
  map.put("_on", Res.string._on)
  map.put("about", Res.string.about)
  map.put("ad_mob_banner_id", Res.string.ad_mob_banner_id)
  map.put("ad_mob_list_item_native_id", Res.string.ad_mob_list_item_native_id)
  map.put("ad_mob_main_page_native_id", Res.string.ad_mob_main_page_native_id)
  map.put("ad_mob_setting_page_native_id", Res.string.ad_mob_setting_page_native_id)
  map.put("ad_mob_splash_id", Res.string.ad_mob_splash_id)
  map.put("ad_mob_test_banner_id", Res.string.ad_mob_test_banner_id)
  map.put("ad_mob_test_list_item_native_1_id", Res.string.ad_mob_test_list_item_native_1_id)
  map.put("ad_mob_test_list_item_native_id", Res.string.ad_mob_test_list_item_native_id)
  map.put("ad_mob_test_splash_id", Res.string.ad_mob_test_splash_id)
  map.put("add", Res.string.add)
  map.put("addSource", Res.string.addSource)
  map.put("add_success", Res.string.add_success)
  map.put("ads", Res.string.ads)
  map.put("ads_loading", Res.string.ads_loading)
  map.put("ai_allow_cleartext", Res.string.ai_allow_cleartext)
  map.put("ai_attempt_history", Res.string.ai_attempt_history)
  map.put("ai_attempt_number", Res.string.ai_attempt_number)
  map.put("ai_base_url", Res.string.ai_base_url)
  map.put("ai_cancel_confirm", Res.string.ai_cancel_confirm)
  map.put("ai_cancel_task", Res.string.ai_cancel_task)
  map.put("ai_cancel_upstream_warning", Res.string.ai_cancel_upstream_warning)
  map.put("ai_capability_image_to_image", Res.string.ai_capability_image_to_image)
  map.put("ai_capability_image_understanding", Res.string.ai_capability_image_understanding)
  map.put("ai_cleartext_warning", Res.string.ai_cleartext_warning)
  map.put("ai_configuration_description", Res.string.ai_configuration_description)
  map.put("ai_configuration_snapshot", Res.string.ai_configuration_snapshot)
  map.put("ai_configuration_title", Res.string.ai_configuration_title)
  map.put("ai_configure_service", Res.string.ai_configure_service)
  map.put("ai_connection_test_action", Res.string.ai_connection_test_action)
  map.put("ai_connection_test_available", Res.string.ai_connection_test_available)
  map.put("ai_connection_test_failed", Res.string.ai_connection_test_failed)
  map.put("ai_connection_test_note", Res.string.ai_connection_test_note)
  map.put("ai_copy_image", Res.string.ai_copy_image)
  map.put("ai_created_at", Res.string.ai_created_at)
  map.put("ai_creation_center_title", Res.string.ai_creation_center_title)
  map.put("ai_creation_info", Res.string.ai_creation_info)
  map.put("ai_creations_empty", Res.string.ai_creations_empty)
  map.put("ai_credential_origin_change_warning", Res.string.ai_credential_origin_change_warning)
  map.put("ai_delete_failed", Res.string.ai_delete_failed)
  map.put("ai_delete_image_confirm", Res.string.ai_delete_image_confirm)
  map.put("ai_delete_task", Res.string.ai_delete_task)
  map.put("ai_error_category", Res.string.ai_error_category)
  map.put("ai_face_detected", Res.string.ai_face_detected)
  map.put("ai_face_detection_unknown", Res.string.ai_face_detection_unknown)
  map.put("ai_face_not_detected", Res.string.ai_face_not_detected)
  map.put("ai_file_history", Res.string.ai_file_history)
  map.put("ai_gallery", Res.string.ai_gallery)
  map.put("ai_generate_action", Res.string.ai_generate_action)
  map.put("ai_generate_title", Res.string.ai_generate_title)
  map.put("ai_generated_badge", Res.string.ai_generated_badge)
  map.put("ai_generated_image_description", Res.string.ai_generated_image_description)
  map.put("ai_generation_cancel_failed", Res.string.ai_generation_cancel_failed)
  map.put("ai_generation_enqueue_failed", Res.string.ai_generation_enqueue_failed)
  map.put("ai_generation_privacy_notice", Res.string.ai_generation_privacy_notice)
  map.put("ai_generation_profile_required", Res.string.ai_generation_profile_required)
  map.put("ai_generation_retry_failed", Res.string.ai_generation_retry_failed)
  map.put("ai_image_copied", Res.string.ai_image_copied)
  map.put("ai_image_save_failed", Res.string.ai_image_save_failed)
  map.put("ai_image_saved", Res.string.ai_image_saved)
  map.put("ai_image_summary_face_detection_failed", Res.string.ai_image_summary_face_detection_failed)
  map.put("ai_image_summary_face_privacy", Res.string.ai_image_summary_face_privacy)
  map.put("ai_image_summary_face_privacy_blocked", Res.string.ai_image_summary_face_privacy_blocked)
  map.put("ai_image_summary_face_privacy_description", Res.string.ai_image_summary_face_privacy_description)
  map.put("ai_image_summary_failed", Res.string.ai_image_summary_failed)
  map.put("ai_image_summary_generating", Res.string.ai_image_summary_generating)
  map.put("ai_local_storage_reclaimable", Res.string.ai_local_storage_reclaimable)
  map.put("ai_model", Res.string.ai_model)
  map.put("ai_model_catalog_empty", Res.string.ai_model_catalog_empty)
  map.put("ai_model_catalog_failed", Res.string.ai_model_catalog_failed)
  map.put("ai_model_catalog_load", Res.string.ai_model_catalog_load)
  map.put("ai_model_catalog_unsupported", Res.string.ai_model_catalog_unsupported)
  map.put("ai_model_generation_hint", Res.string.ai_model_generation_hint)
  map.put("ai_model_understanding_hint", Res.string.ai_model_understanding_hint)
  map.put("ai_more_actions", Res.string.ai_more_actions)
  map.put("ai_new_configuration", Res.string.ai_new_configuration)
  map.put("ai_next_creation", Res.string.ai_next_creation)
  map.put("ai_origin_change_confirm", Res.string.ai_origin_change_confirm)
  map.put("ai_original_metadata", Res.string.ai_original_metadata)
  map.put("ai_previous_creation", Res.string.ai_previous_creation)
  map.put("ai_processing_time", Res.string.ai_processing_time)
  map.put("ai_profile_archive", Res.string.ai_profile_archive)
  map.put("ai_profile_archive_confirm", Res.string.ai_profile_archive_confirm)
  map.put("ai_profile_archive_pending_tasks", Res.string.ai_profile_archive_pending_tasks)
  map.put("ai_profile_delete_confirm", Res.string.ai_profile_delete_confirm)
  map.put("ai_profile_delete_named", Res.string.ai_profile_delete_named)
  map.put("ai_profile_delete_pending_tasks", Res.string.ai_profile_delete_pending_tasks)
  map.put("ai_profile_edit", Res.string.ai_profile_edit)
  map.put("ai_profile_edit_named", Res.string.ai_profile_edit_named)
  map.put("ai_profile_empty_compact", Res.string.ai_profile_empty_compact)
  map.put("ai_profile_error_archive_failed", Res.string.ai_profile_error_archive_failed)
  map.put("ai_profile_error_cleartext_confirmation", Res.string.ai_profile_error_cleartext_confirmation)
  map.put("ai_profile_error_load_failed", Res.string.ai_profile_error_load_failed)
  map.put("ai_profile_error_model_invalid", Res.string.ai_profile_error_model_invalid)
  map.put("ai_profile_error_name_required", Res.string.ai_profile_error_name_required)
  map.put("ai_profile_error_save_failed", Res.string.ai_profile_error_save_failed)
  map.put("ai_profile_error_token_required", Res.string.ai_profile_error_token_required)
}
